import clsx from "clsx";
import React from "react";

type SpaceGuestBadgeProps = {
    className?: string;
};
export default function SpaceGuestBadge(props: SpaceGuestBadgeProps) {
    const { className } = props;
    return (
        <div
            className={clsx(
                "bg-[#F6F6FD] text-[#6562E5] text-[12px] font-rocGroteskMedium rounded-lg px-[8px] py-[6px] leading-none",
                className
            )}
        >
            Guest
        </div>
    );
}
